var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-app",
    { attrs: { id: "inspire" } },
    [
      _c("Spinner"),
      _vm.classification
        ? _c(
            "span",
            {
              staticClass: "classification-footer",
              style: _vm.classificationStyle,
            },
            [_vm._v(" " + _vm._s(_vm.classification) + " ")]
          )
        : _vm._e(),
      _c("router-view", {
        key: _vm.$route.fullPath,
        class: _vm.classification ? "pt-5" : "",
      }),
      _c("v-spacer"),
      _c("Footer"),
      _c("Snackbar"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }